<template>
  <el-dialog class="tpl-word-user-dialog global-dialog"
             @closed="onDialogClosed"
             title="编辑表格内容"
             :width="`${dialogWidth}px`"
             :visible.sync="dialogVisible">
    <div class="twd-body">
      <div class="twd-content">
        <div class="twd-c-body"  v-loading="fontLoading"
             element-loading-text="正在加载中..."
             element-loading-spinner="el-icon-loading">
          <textarea id="mytextarea_user"></textarea>
        </div>
      </div>
      <div style="height:0px;overflow:auto;">
        <word-to-img ref="wordImgRef" :key="domToimgKey" :bg-color="bgColor" :html-str="imgData" :w-width="data.width"
                     :w-height="data.height"></word-to-img>
      </div>
    </div>
    <div slot="footer" class="footer-tools">
      <div class="op-bar">
        <div class="item">
          <label>行数 </label>
          <el-input :value="rowNum">
            <div slot="suffix" class="arrow-box">
              <i class="el-icon-arrow-up arrow-icon" @click="handleChangeRow(true)"></i>
              <i class="el-icon-arrow-down arrow-icon" @click="handleChangeRow(false)"></i>
            </div>
          </el-input>
        </div>
        <div class="item">
          <label>列数 </label>
          <el-input :value="colNum">
            <div slot="suffix" class="arrow-box">
              <i class="el-icon-arrow-up arrow-icon" @click="handleChangeCol(true)"></i>
              <i class="el-icon-arrow-down arrow-icon" @click="handleChangeCol(false)"></i>
            </div>
          </el-input>
        </div>
        <el-button @click="clearContent">清除数据</el-button>
      </div>
      <div>
        <el-button type="primary" round @click="onConfirm" :loading="confirmLoading">确认</el-button>
        <el-button type="default" round @click="onClose">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
    import wordToImg from './word-to-img'
    import {material_type} from '@/const.js';
    import {default_table_html} from './table-html'
    import TUtil from "../TUtil";

    const tinymce_selector = '#mytextarea_user';
    const tinymce_margin = 28;
    const dialog_padding = 40 * 2;
    export default {
        components: {wordToImg},
        props: {
            value: {
                type: Boolean, default: false
            },
            data: Object,
            projectId: String,
            currentTemplateId: String,
            templateIds: Array,
            isPPT: Boolean
        },
        data () {
            return {
                imgData: '',
                confirmLoading: false,
                loading: false,
                activeId: null,
                defaultData: [],
                domToimgKey: 0,
                imgList: [],
                rowNum: 3,
                colNum: 2,
                dialogWidth: 700,
                fontLoading: false,
                bgColor: '#fff'
            }
        },
        computed: {
            dialogVisible: {
                get () {
                    return this.value;
                },
                set (v) {
                    this.$emit('input', v);
                }
            },
            getBodyWidth () {
                return `width: ${+this.data.width + tinymce_margin + 280}px`
            }
        },
        watch: {
            dialogVisible: {
                handler (v) {
                    if (v) {
                        this.$nextTick(() => {
                            this.init()
                        })
                    }
                },
                immediate: true
            }
        },
        methods: {
            init () {
                this.initEditor();
            },
            initEditor () {
                let self = this, tableW = +this.data.width, bodyWidth = document.body.offsetWidth - dialog_padding;
                let width = tableW + tinymce_margin;
                this.dialogWidth = tableW > bodyWidth ? bodyWidth : tableW + dialog_padding + tinymce_margin;
                let height = +this.data.height + tinymce_margin;
                let defFontFamily = this.data.fontFamily || '';
                if (!tinymce.activeEditor) {
                    tinymce.init({
                        selector: tinymce_selector,
                        language: 'zh_CN',
                        language_url: 'js/tinymce/langs/zh_CN.js',
                        content_css: 'js/tinymce/tinymce-reset.css, js/tinymce/tinymce-table.css',
                        content_style: `.mce-resizehandle{display: none} table{font-family: ${defFontFamily}`,
                        branding: false,
                        menubar: false,
                        statusbar: false,
                        elementpath: false,
                        theme_advanced_resizing: true,
                        height: height,
                        width: width,
                        plugins: "table paste",
                        paste_retain_style_properties: "all",
                        toolbar: [],
                        table_toolbar: '',
                        auto_focus: true,
                        contextmenu: '',
                        table_resize_bars: false,
                        contextmenu_never_use_native: true,
                        setup: (editor) => {
                            editor.on('init', () => {
                                this.setContentForInit();
                            });
                            editor.on('load', (e) => {
                                this.initFontInFrame(e.target.iframeElement.contentWindow, this.getTextFontList());
                            });
                            editor.on('click', (e) => {
                                let arr = tinymce.activeEditor.selection.getSelectedBlocks();
                                let table = tinymce.activeEditor.getBody().querySelector('table');
                                if(arr && arr.length > 0 && table && !table.contains(arr[0])){
                                    //非表格内元素不让编辑，阻止获取焦点，让焦点跑到最后一行
                                    this.setCursorToLastRow();
                                }
                            });
                        },
                        init_instance_callback: (editor) => {
                        }
                    });
                } else {
                    this.setContentForInit();
                }
            },
            async initFontInFrame(iframeWin, fontList){
                this.fontLoading = true;
                let item;
                for(let i in fontList){
                    item = fontList[i];
                    await this.downloadFontByUrl(iframeWin, item.name, item.url);
                }
                this.fontLoading = false;
            },
            downloadFontByUrl(iframeWin, name, url){
                let fontFace = new iframeWin.FontFace(name, `url(${url})`);
                return new Promise((resolve, reject) => {
                    fontFace.load().then((font) => {
                        iframeWin.document.fonts.add(font);
                        resolve(true);
                    }).catch((error) => {
                        console.error(`字体解析异常：${name}`);
                        reject(error);
                    });
                });
            },
            getTextFontList(){
                let fontStr = this.data.fontFamily;
                if(!fontStr){
                    return;
                }
                let projectFontList = this.$store.state.app.projectFontList, fontMap = {},
                    fontObjList = [],
                    missingFontList = [],
                    fontNameList = Array.from(new Set(fontStr.split(',')));
                projectFontList.map((item) => {
                    fontMap[item.name] = item;
                });
                fontNameList.forEach((name) => {
                    if(fontMap[name]){
                        fontObjList.push(fontMap[name]);
                    }else{
                        missingFontList.push(name);
                    }
                });
                // if(missingFontList.length > 0){
                //     console.error(`富文本编辑器缺失字体: ${missingFontList.join(',')}, 请到后台项目字体管理中添加字体`)
                // }
                return fontObjList;
            },
            setContentForInit () {
                tinymce.activeEditor.setContent(this.data.htmlStr || default_table_html.join(''));
                let tableHtml = this.data.htmlStr || default_table_html.join('');
                let row = tableHtml.split('<tr').length - 1;
                let col = (tableHtml.split('<td').length - 1) / row;
                this.rowNum = row;
                this.colNum = col;
                this.setCursorToLastRow();
            },
            onClose () {
                this.dialogVisible = false;
            },
            getImg () {
                let content = tinymce.activeEditor.getContent();
                this.domToimgKey += 1;
                this.imgData = content;
                return TUtil.tableToImg(this, content);
            },
            setTableStyle(){
                let pTable = tinymce.activeEditor.getBody().querySelector('.t-round');
                // this.bgColor = pTable ? 'rgba(0,0,0,0)': '#fff';
                 this.data.borderRadius = pTable ? 10 : 0;
            },
            onConfirm () {
                if (!this.validateTableHeight(0)) {
                    return;
                }
                this.setTableStyle();
                let content = tinymce.activeEditor.getContent();
                if (content && content.indexOf('table') > -1) {
                    this.confirmLoading = true;
                    this.getImg().then((data) => {
                        this.$emit('onConfirm', data);
                    }).finally(() => {
                        this.dialogVisible = false;
                        this.confirmLoading = false;
                    });
                } else {
                    this.$message.error('表格不能为空')
                }
            },
            onDialogClosed () {
                tinymce.remove('#mytextarea_user');
                tinymce.activeEditor = null;
            },
            getFocusHeight () {
                var tdList = tinymce.activeEditor.selection.getSelectedBlocks();
                if (tdList.length > 0 && tdList[0].tagName.toLowerCase() === 'td') {
                    return tdList[0].offsetHeight;
                } else {
                    return null;
                }
            },
            setNewTrHeight (height) {
                var tdList = tinymce.activeEditor.selection.getSelectedBlocks();
                if (tdList.length > 0 && tdList[0].tagName.toLowerCase() === 'td') {
                    tdList[0].parentElement.style.height = `${height}px`;
                }
            },
            validateTableHeight (oldTrHeight) {
                if (!this.isPPT) { // 非ppt模板不做表格高度验证
                    return true;
                }
                let table = tinymce.activeEditor.getBody().querySelector('table');
                if (!table) {
                    return true;
                }
                let newTableHeight = table.offsetHeight + oldTrHeight;
                let maxHeight = +this.data.height;
                if (newTableHeight > maxHeight) {
                    this.$message.error(`当前表格高度过长，无法再添加新的行`);
                    return false
                }
                return true;
            },
            handleChangeRow (value) {
                let oldTrHeight = this.getFocusHeight();
                if (value) {
                    if (!this.validateTableHeight(oldTrHeight)) {
                        return;
                    }
                    tinymce.execCommand("mceTableInsertRowAfter");
                    if (oldTrHeight) {
                        this.updateHeightByRowChange(oldTrHeight);
                        this.setNewTrHeight(oldTrHeight);
                    }
                } else {
                    if (this.rowNum < 2) {
                        return;
                    }
                    if(oldTrHeight){
                        this.updateHeightByRowChange(-oldTrHeight);
                    }
                    tinymce.execCommand("mceTableDeleteRow");
                    this.setCursorToLastRow();
                }
                let html = tinymce.activeEditor.getContent();
                let oldNum = this.rowNum;
                this.rowNum = html.split('<tr').length - 1;
                if (this.rowNum === oldNum) {
                    this.$message.error('请先点击要操作的行列')
                }
            },
            handleChangeCol (value) {
                if (value) {
                    tinymce.execCommand("mceTableInsertColAfter");
                } else {
                    if (this.colNum < 2) {
                        return;
                    }
                    tinymce.execCommand("mceTableDeleteCol");
                }
                let html = tinymce.activeEditor.getContent();
                let oldNum = this.colNum;
                this.colNum = (html.split('<td').length - 1) / this.rowNum;
                if (this.colNum === oldNum) {
                    this.$message.info('请先点击要操作的行列')
                }
            },
            setCursorToLastRow(){
                tinymce.activeEditor.selection.setCursorLocation(tinymce.activeEditor.getBody().querySelector('table tr:last-child td'));
            },
            clearContent () {
                let tdList = tinymce.activeEditor.getBody().querySelectorAll('table td');
                tdList.forEach((td) => {
                    td.innerHTML = '&nbsp;'
                });
            },
            updateHeightByRowChange(height){
               let tableDom = tinymce.activeEditor.getBody().querySelector('table');
                tableDom.style.height = `${tableDom.offsetHeight + height}px`;
                tableDom.setAttribute('data-mce-style', tableDom.style.cssText);
            }
        }
    }
</script>
<style lang="scss">
  @import "./word-user-dialog.scss";
</style>